// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';

export async function getRoutes() {
  const routes = {"1":{"path":"/callback","layout":false,"id":"1"},"2":{"path":"/user","layout":false,"id":"2"},"3":{"name":"login","path":"/user/login","parentId":"2","id":"3"},"4":{"path":"/user/access-denied","parentId":"2","id":"4"},"5":{"path":"/workbench","name":"工作台","icon":"dashboard","parentId":"ant-design-pro-layout","id":"5"},"6":{"path":"/scheduler/jobs","name":"定时任务","icon":"clockCircle","parentId":"ant-design-pro-layout","id":"6"},"7":{"path":"/scheduler/logs","name":"执行日志","icon":"history","parentId":"ant-design-pro-layout","id":"7"},"8":{"path":"/","redirect":"/workbench","parentId":"ant-design-pro-layout","id":"8"},"9":{"path":"*","layout":false,"id":"9"},"ant-design-pro-layout":{"id":"ant-design-pro-layout","path":"/","isLayout":true}} as const;
  return {
    routes,
    routeComponents: {
'1': React.lazy(() => import(/* webpackChunkName: "p__callback" */'@/pages/callback.tsx')),
'2': React.lazy(() => import('./EmptyRoute')),
'3': React.lazy(() => import(/* webpackChunkName: "p__user__login__index" */'@/pages/user/login/index.tsx')),
'4': React.lazy(() => import(/* webpackChunkName: "p__user__access-denied__index" */'@/pages/user/access-denied/index.tsx')),
'5': React.lazy(() => import(/* webpackChunkName: "p__Workbench__index" */'@/pages/Workbench/index.tsx')),
'6': React.lazy(() => import(/* webpackChunkName: "p__scheduler__jobs__index" */'@/pages/scheduler/jobs/index.tsx')),
'7': React.lazy(() => import(/* webpackChunkName: "p__scheduler__logs__index" */'@/pages/scheduler/logs/index.tsx')),
'8': React.lazy(() => import('./EmptyRoute')),
'9': React.lazy(() => import(/* webpackChunkName: "p__404" */'@/pages/404.tsx')),
'ant-design-pro-layout': React.lazy(() => import(/* webpackChunkName: "t__plugin-layout__Layout" */'/app/src/.umi-production/plugin-layout/Layout.tsx')),
},
  };
}
